import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=ba485076&scoped=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=ba485076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba485076",
  null
  
)

export default component.exports